import React from 'react';
import { motion } from 'framer-motion';
import { PackageIcon } from 'lucide-react';
type BonusItem = {
  title: string;
  description: string;
  accent: string;
  glowColor: string;
  image?: string;
};
const bonuses: BonusItem[] = [{
  title: 'Plantilla de control de clientes',
  description: 'Sistema simple para organizar la información de tus clientes contables.',
  accent: 'border-green-500/20',
  glowColor: 'rgba(34,197,94,0.12)',
  image: 'https://cdn.magicpatterns.com/uploads/ifusRrDLJP6zqVGwjtHwcC/bono_1.png'
}, {
  title: 'Checklist mensual contable',
  description: 'Lista práctica para controlar tareas contables y vencimientos mensuales.',
  accent: 'border-orange-500/20',
  glowColor: 'rgba(249,115,22,0.12)',
  image: 'https://cdn.magicpatterns.com/uploads/mv4BC3wtjtFC23bzzUNs6G/bono_2.png'
}, {
  title: 'Calendario de vencimientos fiscales',
  description: 'Calendario para organizar fechas clave y evitar olvidos en presentaciones fiscales.',
  accent: 'border-blue-500/20',
  glowColor: 'rgba(59,130,246,0.12)',
  image: 'https://cdn.magicpatterns.com/uploads/agj8nDkftMpb1eV8Vr15Rf/bono_3.png'
}, {
  title: 'Seguimiento de pagos de clientes',
  description: 'Plantilla para registrar pagos y mantener control financiero de tus clientes.',
  accent: 'border-yellow-500/20',
  glowColor: 'rgba(234,179,8,0.12)',
  image: 'https://cdn.magicpatterns.com/uploads/kgV9vf2Dr8yoLUYtRmaBY1/bono_4.png'
}, {
  title: 'Formularios para nuevos clientes',
  description: 'Documentos para registrar información de nuevos clientes de forma profesional.',
  accent: 'border-red-500/20',
  glowColor: 'rgba(239,68,68,0.12)',
  image: 'https://cdn.magicpatterns.com/uploads/kZReYJU7UeS2vfPtGyYLyg/bono_5.png'
}, {
  title: 'Sistema de organización digital',
  description: 'Estructura para mantener archivos contables y documentación ordenada.',
  accent: 'border-emerald-500/20',
  glowColor: 'rgba(5,150,105,0.12)',
  image: 'https://cdn.magicpatterns.com/uploads/hdGMFfhLTpSxc4d64uHBd4/bono_6.png'
}];
function Book6SVG() {
  return <svg viewBox="0 0 180 220" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-32">
      <defs data-id="element-33">
        <linearGradient id="cover6" x1="0" y1="0" x2="1" y2="1" data-id="element-34">
          <stop offset="0%" stopColor="#059669" data-id="element-35" />
          <stop offset="100%" stopColor="#065f46" data-id="element-36" />
        </linearGradient>
        <linearGradient id="spine6" x1="0" y1="0" x2="1" y2="0" data-id="element-37">
          <stop offset="0%" stopColor="#065f46" data-id="element-38" />
          <stop offset="100%" stopColor="#059669" stopOpacity="0.7" data-id="element-39" />
        </linearGradient>
        <linearGradient id="gold6" x1="0" y1="0" x2="1" y2="1" data-id="element-40">
          <stop offset="0%" stopColor="#caa64a" data-id="element-41" />
          <stop offset="50%" stopColor="#f9e076" data-id="element-42" />
          <stop offset="100%" stopColor="#caa64a" data-id="element-43" />
        </linearGradient>
      </defs>
      <ellipse cx="95" cy="212" rx="60" ry="6" fill="black" opacity="0.25" data-id="element-44" />
      <rect x="30" y="18" width="12" height="185" rx="1" fill="#e8e0d0" data-id="element-45" />
      <rect x="31" y="20" width="10" height="181" rx="1" fill="#f5f0e8" data-id="element-46" />
      {[30, 50, 70, 90, 110, 130, 150, 170, 190].map(y => <line key={y} x1="32" y1={y} x2="40" y2={y} stroke="#d4cfc5" strokeWidth="0.5" data-id="element-47" />)}
      <rect x="38" y="15" width="16" height="192" rx="2" fill="url(#spine6)" data-id="element-48" />
      <rect x="44" y="15" width="2" height="192" fill="url(#gold6)" opacity="0.6" data-id="element-49" />
      <rect x="50" y="12" width="105" height="196" rx="4" fill="url(#cover6)" data-id="element-50" />
      <rect x="58" y="20" width="89" height="180" rx="3" stroke="url(#gold6)" strokeWidth="1.5" fill="none" opacity="0.5" data-id="element-51" />
      <rect x="62" y="28" width="81" height="2" rx="1" fill="url(#gold6)" opacity="0.7" data-id="element-52" />
      <circle cx="102" cy="80" r="28" fill="white" opacity="0.1" data-id="element-53" />
      <text x="102" y="90" textAnchor="middle" fontSize="32" fill="white" opacity="0.9" data-id="element-54">
        📂
      </text>
      <rect x="68" y="118" width="69" height="1.5" rx="0.75" fill="url(#gold6)" opacity="0.6" data-id="element-55" />
      <rect x="68" y="130" width="69" height="5" rx="2" fill="white" opacity="0.25" data-id="element-56" />
      <rect x="74" y="142" width="57" height="4" rx="2" fill="white" opacity="0.15" data-id="element-57" />
      <rect x="78" y="152" width="49" height="4" rx="2" fill="white" opacity="0.12" data-id="element-58" />
      <rect x="62" y="170" width="81" height="2" rx="1" fill="url(#gold6)" opacity="0.5" data-id="element-59" />
      <circle cx="66" cy="190" r="2" fill="url(#gold6)" opacity="0.4" data-id="element-60" />
      <circle cx="139" cy="190" r="2" fill="url(#gold6)" opacity="0.4" data-id="element-61" />
    </svg>;
}
export function BonusSection() {
  return <section className="py-20 px-4 bg-[#0B1A2E]" data-id="element-62">
      <div className="max-w-6xl mx-auto" data-id="element-63">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-64">
          <span className="inline-block text-blue-400 font-semibold tracking-wider text-xs sm:text-sm uppercase bg-blue-900/20 px-4 py-1.5 rounded-full border border-blue-800/40 mb-5" data-id="element-65">
            Bonos incluidos en el sistema
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-66">
            Además del sistema base, recibes estos regalos profesionales
          </h2>
        </motion.div>

        {/* Bonus cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-67">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className={`bg-slate-800/50 border border-slate-700/60 ${bonus.accent} rounded-2xl overflow-hidden group hover:border-slate-600 transition-colors`} data-id="element-68">
              {/* Book image area */}
              <div className="relative bg-[#0f172a] flex items-center justify-center h-56 overflow-hidden" data-id="element-69">
                {/* Glow behind book */}
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-70">
                  <div className="w-36 h-36 rounded-full blur-[45px]" style={{
                backgroundColor: bonus.glowColor
              }} data-id="element-71" />
                </div>

                {bonus.image ? <img src={bonus.image} alt={bonus.title} className="relative z-10 h-48 w-auto object-contain" style={{
              filter: 'drop-shadow(0 18px 30px rgba(0,0,0,0.6))'
            }} data-id="element-72" /> : <div className="relative z-10 h-48 w-auto" data-id="element-73">
                    <Book6SVG data-id="element-74" />
                  </div>}

                {/* Badge */}
                <div className="absolute top-3 right-3 bg-green-500 text-white text-[10px] font-extrabold px-2.5 py-1 rounded-full uppercase tracking-wider shadow-md z-20" data-id="element-75">
                  Gratis hoy
                </div>
              </div>

              {/* Content */}
              <div className="p-5" data-id="element-76">
                <h3 className="text-base font-bold text-white mb-2 leading-snug" data-id="element-77">
                  {bonus.title}
                </h3>
                <p className="text-sm text-slate-400 leading-relaxed" data-id="element-78">
                  {bonus.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* Closing card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-8" data-id="element-79">
          <div className="bg-gradient-to-r from-blue-600/20 via-blue-500/10 to-blue-600/20 border border-blue-500/30 rounded-2xl p-8 md:p-10 text-center relative overflow-hidden" data-id="element-80">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(59,130,246,0.08),transparent_70%)]" data-id="element-81" />
            <div className="relative z-10 flex flex-col items-center gap-4" data-id="element-82">
              <div className="bg-blue-500/15 p-3 rounded-full" data-id="element-83">
                <PackageIcon className="w-8 h-8 text-blue-400" data-id="element-84" />
              </div>
              <p className="text-2xl md:text-3xl font-bold text-white" data-id="element-85">
                Te llevas todo este pack completo solo por hoy.
              </p>
              <p className="text-slate-400 text-base max-w-md" data-id="element-86">
                Accede al sistema principal y los 6 bonos profesionales
                incluidos sin costo adicional.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}